import { DataTable } from 'redux-database';
import { User } from './user';
import { Membership } from './membership';
import { Shop } from './shop';
import { Category } from './category';
import { Session } from './session';
import { Company } from './company';
import { Event, PricingCategory } from './event';
import { Country } from './country';
import { Tour } from './tour';
import { Venue } from './venue';
import { Logo } from './logo';
import { writeDB } from './store';
import { Product } from './product';
import { Order } from './order';
import { StorageLocation } from './storageLocation';
import { Notification } from './notification';
import { Picklist } from './picklist';
import { Activity } from './activity';
import { Delivery } from './delivery';
import { Queue, QueueStat } from './queue';
import { News } from './news';
import { Contract } from './contract';
import { ServerScaling, ScalingSchedule } from './server';
import { TimeSeriesPoint } from './statistics';
import { MerchStatsVariant } from './merchStatistics';
import { TicketScannerActivityLogItem } from './ticketScanner';
import { OrderStatisticsIp } from './order_statistics_ip';
import { OrderStatisticsPaymentFingerprint } from './order_statistics_payment_fingerprint';

export interface MostUsedFilters {
  orders?: Array<{ id: string; count: number }>;
}

export interface State {
  settings: {
    session?: Session | undefined;
    selectedMembership?: string;
    sidebarOpen?: boolean;
    persist: boolean;
    canCreateEvents?: boolean;
    canCreateTours?: boolean;
    queue?: Queue;
    printLabel?: boolean;
    printTickets?: boolean;
    useNewCSVDownload?: boolean;
    autoCancelDisabled?: boolean;
    apiOverride?: string;
    mostUsedFilters?: MostUsedFilters;
    queueActiveSessionsAge?: QueueStat;
    queueSessionsAge?: QueueStat;
    queueSessionWaitTime?: QueueStat;
    serverScalingStatus?: ServerScaling;
    ordersPerMinute?: TimeSeriesPoint[];
    ordersCreatedPerMinute?: TimeSeriesPoint[];
    paymentsPerMinute?: TimeSeriesPoint[];
    topIps?: OrderStatisticsIp[];
    topPaymentFingerprints?: OrderStatisticsPaymentFingerprint[];
  };
  data: {
    users: DataTable<User>;
    memberships: DataTable<Membership>;
    shops: DataTable<Shop>;
    categories: DataTable<Category>;
    companies: DataTable<Company>;
    events: DataTable<Event>;
    pricingCategories: DataTable<PricingCategory>;
    countries: DataTable<Country>;
    tours: DataTable<Tour>;
    venues: DataTable<Venue>;
    logos: DataTable<Logo>;
    products: DataTable<Product>;
    orders: DataTable<Order>;
    storageLocations: DataTable<StorageLocation>;
    notifications: DataTable<Notification>;
    picklists: DataTable<Picklist>;
    activities: DataTable<Activity>;
    deliveries: DataTable<Delivery>;
    news: DataTable<News>;
    contracts: DataTable<Contract>;
    scalingSchedules: DataTable<ScalingSchedule>;
    statisticsProductVariants: DataTable<MerchStatsVariant>;
    activityLog: DataTable<TicketScannerActivityLogItem>;
  };
}

const emptyTable = {
  byId: {},
  ids: [],
};

export const initialState: State = {
  data: {
    users: emptyTable,
    memberships: emptyTable,
    shops: emptyTable,
    categories: emptyTable,
    companies: emptyTable,
    events: emptyTable,
    pricingCategories: emptyTable,
    countries: emptyTable,
    tours: emptyTable,
    venues: emptyTable,
    logos: emptyTable,
    products: emptyTable,
    orders: emptyTable,
    storageLocations: emptyTable,
    notifications: emptyTable,
    picklists: emptyTable,
    activities: emptyTable,
    deliveries: emptyTable,
    news: emptyTable,
    contracts: emptyTable,
    scalingSchedules: emptyTable,
    statisticsProductVariants: emptyTable,
    activityLog: emptyTable,
  },
  settings: {
    persist: false,
  },
};

export function resetDB(): void {
  writeDB.table('memberships').delete(writeDB.table('memberships').ids);
  writeDB.table('events').delete(writeDB.table('events').ids);
}
